import { render, staticRenderFns } from "./salmonthcountdif.vue?vue&type=template&id=ce81ae1e&scoped=true&"
import script from "./salmonthcountdif.vue?vue&type=script&lang=js&"
export * from "./salmonthcountdif.vue?vue&type=script&lang=js&"
import style0 from "./salmonthcountdif.vue?vue&type=style&index=0&id=ce81ae1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce81ae1e",
  null
  
)

export default component.exports